document.addEventListener('DOMContentLoaded', () => {

    // tooltip
    // const tooltips = document.querySelectorAll('.membership-tooltip');

    // tooltips.forEach(tooltip => {
    //     const btn = tooltip.querySelector('.tooltip-button');
    //     const close = tooltip.querySelector('.membership-tooltip__close');

    //     const handleClickOutside = event => {
    //         if (!tooltip.contains(event.target) && !btn.contains(event.target)) {
    //             tooltip.classList.remove('membership-tooltip--active');
    //             document.removeEventListener('click', handleClickOutside);
    //         }
    //     };

    //     btn.addEventListener('click', () => {
    //         const isActive = tooltip.classList.toggle('membership-tooltip--active');
    //         if (isActive) {
    //             document.addEventListener('click', handleClickOutside);
    //         } else {
    //             document.removeEventListener('click', handleClickOutside);
    //         }
    //     });
        
    //     close.addEventListener('click', () => {
    //         tooltip.classList.remove('membership-tooltip--active');
    //         document.removeEventListener('click', handleClickOutside);
    //     });
    // });
    
    
    // grade toggle
    const gradeToggle = document.querySelectorAll('.grade-title');
    const gradeList = document.querySelectorAll('.grade-list');

    // const gradeTransition = (target) => {
    //     target.addEventListener('transitionend', () => {
    //         target.classList.toggle('grade-list--active');
    //     });
    // }

    const gradeListOpen = (target) => {
        const height = Math.ceil(target.scrollHeight + 1);
        target.style.setProperty('--max-height', `${height}px`);
    }

    gradeList.forEach(list => {
        list.addEventListener('transitionend', e => {
            const hasActive = e.target.closest('.membership__reward-grade').querySelector('.grade-title').classList.contains('grade-title--active');
            hasActive ? e.target.style.setProperty('overflow', 'unset') : e.target.style.setProperty('overflow', 'hidden');
        });
    });

    gradeToggle.forEach(btn => {
        btn.addEventListener('click', e => {
            const target = e.currentTarget;
            const hasActive = target.classList.contains('grade-title--active');
            target.classList.toggle('grade-title--active');
            hasActive && target.closest('.membership__reward-grade').querySelector('.grade-list').style.setProperty('overflow', 'hidden');
            gradeListOpen(target.closest('.membership__reward-grade').querySelector('.grade-list'), hasActive);
        });
    });

});